module.exports = __webpack_public_path__ + "img/infoIcon.36f6369c.svg";